import { useAppStore } from '@/store';
import ImportView from '@/views/ImportView';
import DiagnoseView from '@/views/DiagnoseView';
import DomainView from '@/views/DomainView';
import BuildView from '@/views/BuildView';
import ExportView from '@/views/ExportView';
import ApplyView from '@/views/ApplyView';
import NavBar from '@/components/NavBar';

const VIEWS = {
  import:   ImportView,
  diagnose: DiagnoseView,
  domain:   DomainView,
  build:    BuildView,
  export:   ExportView,
  apply:    ApplyView,
} as const;

export default function App() {
  const view = useAppStore(s => s.currentView);
  const View = VIEWS[view];

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-slate-900 text-slate-100">
      <NavBar />
      <main className="flex-1 overflow-auto">
        <View />
      </main>
    </div>
  );
}
